import { render } from "./single-loading.vue?vue&type=template&id=657a3d2b&scoped=true"
import script from "./single-loading.vue?vue&type=script&lang=js"
export * from "./single-loading.vue?vue&type=script&lang=js"

import "./single-loading.vue?vue&type=style&index=0&id=657a3d2b&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657a3d2b"]])

export default __exports__